<!-- 搜索记录统计 -->
<template>
    <div id="searchCount" class="business-content-main">
        <div class="bread-nav">
            <div>您当前位置：</div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>客服</el-breadcrumb-item>
                <el-breadcrumb-item>数据统计</el-breadcrumb-item>
                <el-breadcrumb-item>搜索记录统计</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-name">时间:</div>
            <el-date-picker
                    :picker-options="startDateOps"
                    class="search-item"
                    v-model="searchData.StartDate"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    size="small"
                    placeholder="选择日期">
            </el-date-picker>
            <span class="search-name">至</span>
            <el-date-picker
                    :picker-options="endDateOps"
                    class="search-item"
                    v-model="searchData.EndDate"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    size="small"
                    placeholder="选择日期">
            </el-date-picker>
            <div class="search-name">搜索类型:</div>
            <el-select
                    size="small"
                    class="search-item"
                    v-model="searchData.Type"
                    placeholder="请选择">
                <el-option
                        v-for="item in searchType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
            <el-button type="primary" size="small" icon="el-icon-search" class="search-btn" @click="handleSearch">查询</el-button>
            <el-button type="primary" size="small" icon="el-icon-refresh" class="search-btn" @click="resetSearch">重置</el-button>
        </div>
        <div class="table-ctn">
            <el-table
                    :header-cell-style="{background:'#F2F6FC'}"
                    :data="tableData"
                    border
                    style="width: 100%">
                <el-table-column
                        show-overflow-tooltip
                        prop="SearchTime"
                        label="搜索人数">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="SearchContent"
                        label="搜索关键词">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="ResultCount"
                        label="搜索次数">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="address"
                        label="获取结果次数">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="SearchType"
                        label="搜索类型">
                </el-table-column>
                <!--<el-table-column-->
                        <!--prop="address"-->
                        <!--label="操作">-->
                    <!--<template slot-scope="scope">-->
                        <!--<el-button type="text" size="small" @click="toHot()">设为热词</el-button>-->
                    <!--</template>-->
                <!--</el-table-column>-->
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[10, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'searchCount',
        components: {},
        data() {
            return {
                startDateOps: {
                    disabledDate: (time) => {
                        if (this.searchData.EndDate != "") {
                            return  time.getTime() > new Date(this.searchData.EndDate);
                        }

                    }
                },
                endDateOps: {
                    disabledDate: (time) => {
                        if (this.searchData.StartDate != "") {
                            return  time.getTime() < new Date(this.searchData.StartDate);
                        }

                    }
                },
                toOrderData:{
                    xjTime:'',
                    bjTime:''
                },
                formLabelWidth: '120px',
                searchType: [
                    {
                        value:0,
                        label:'汽配件'
                    },
                    {
                        value:1,
                        label:'商品'
                    },
                    {
                        value:2,
                        label:'企业'
                    },
                ],
                searchData: {
                    StartDate: '',
                    EndDate: '',
                    Type: '',
                    page:1, // 当前页数
                    limit:10, // 每页限制条数
                },
                tableData: [],
                tableDataLength:0,
            }
        },
        mounted() {
            this.getTableData()
        },
        methods: {
            // 设为热词
            toHot(){
                this.$message({
                    message: '设为热词成功',
                    type: 'success'
                });
            },
            getTableData(){
                this.axios.get('/Statistics/LoadRecordStatistics',{
                    params: this.searchData

                }).then((response)=> {
                        this.tableData = response.data.data
                        this.tableDataLength = response.data.count
                    })
                    .catch((error)=>{
                        console.log(error);
                    });
            },
            handleSearch(){
                this.searchData.page = 1
                this.getTableData()
            },
            resetSearch(){
                this.searchData = {
                    StartDate: '',
                    EndDate: '',
                    Type: '',
                    page:1, // 当前页数
                    limit:10, // 每页限制条数
                }
            },
            handleSizeChange(val) {
                this.searchData.limit = val
                this.getTableData()
            },
            handleCurrentChange(val) {
                this.searchData.page = val
                this.getTableData()
            }
        }
    }
</script>
<style lang="less" scoped>

</style>
